import React__default from 'react';
import { Icon } from '../components/internal/Icon.mjs';

function CheckIcon(props) {
  return /* @__PURE__ */ React__default.createElement(Icon, {
    ...props
  }, /* @__PURE__ */ React__default.createElement("path", {
    d: "M16 6L8 14L4 10"
  }));
}

export { CheckIcon };
//# sourceMappingURL=Check.mjs.map
